import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";
import {ReactSVG} from "react-svg";
import Calendar from "react-calendar";

import * as componentTypes from "../../../../constants/componentTypes";
import * as autotaskTypes from "../../../../constants/autotaskTypes";
import * as validationHelper from "../../../../helpers/validationHelper";
import * as modelHelper from "../../../../helpers/modelHelper";
import * as navigationActions from "../../../../actions/navigationActions";
import * as autotaskActions from "../../../../actions/autotaskActions";
import * as config from "../../../../constants/config";
import * as settings from "../../../../constants/settings";
import * as rcc from "../../../../constants/rcc";
import * as filtering from "../../../../constants/filtering";
import * as resources from "../../../../constants/resources";
import * as formatHelper from "../../../../helpers/formatHelper";
import * as getterHelper from "../../../../helpers/getterHelper";
import * as translationHelper from "../../../../helpers/translationHelper";
import * as tooltipHelper from "../../../../helpers/tooltipHelper";

import imgConfirm from "../../../../resources/img/svgicons/confirm.svg";
import help from "../../../../resources/img/svgicons/help.svg";

import Autotask from "../../../../models/entities/Autotask";
import Modal from "../../../global/generic/Modal";
import CancelButton from "../../../global/generic/CancelButton";
import Button from "../../../global/generic/Button";
import Input from "../../../global/generic/Input";

class AutotaskModal extends Component {
    constructor(props) {
        super(props);

        let autotask = props.params.autotask;

        this.state = {
            create: autotask === null,
            id: autotask === null ? null : autotask.id,
            actionType:
                autotask === null
                    ? this.props.autotaskTypes.length
                        ? this.props.autotaskTypes[0]
                        : ""
                    : autotask.actionType,
            name: autotask === null ? "" : autotask.name,
            startType: autotask === null ? autotaskTypes.START_TYPE_ON_START : autotask.startType,
            enabled: autotask === null ? true : autotask.enabled,
            canPostpone: autotask === null ? true : autotask.canPostpone,
            volume: autotask === null ? rcc.RCC_DEFAULT_PURGE_VOLUME : autotask.volume,
            channels: [],
            canisters: [],
            threshold:
                autotask === null
                    ? formatHelper.convertDecimalToPercent(rcc.RCC_DEFAULT_AUTOTASK_THRESHOLD)
                    : formatHelper.formatDecimalNumber(formatHelper.convertDecimalToPercent(autotask.threshold)),
            repeatIntervalValid: true,
            repeatDayInterval: "0",
            repeatHourInterval: "0",
            repeatMinuteInterval: "0",
            firstRunEditable: false,
            firstRun: null,
            firstRunDate: new Date(),
            firstRunHour: "0",
            firstRunMinute: "0",
            firstRunSecond: "0",
            selectedMonthDays: autotask === null ? [] : autotask.runMonthDays,
            selectedWeekDays: autotask === null ? [] : autotask.runWeekDays,
            monthDayInput: "",
            weekDayInput: "",
            activeDaysMultiselect: null,
            cleaningTime: autotask === null ? this.props.cleaningTime : autotask.cleaningTime,
            recirculationSpeed: autotask === null ? this.props.recirculationSpeed : autotask.recirculationSpeed,
            recirculationTime: autotask === null ? this.props.recirculationTime : autotask.recirculationTime,
            stirringSpeed: autotask === null ? this.props.stirringSpeed : autotask.stirringSpeed,
            stirringTime: autotask === null ? this.props.stirringTime : autotask.stirringTime
        };
    }

    componentDidMount() {
        let autotask = this.props.params.autotask;
        let channels = [];
        let canisters = [];

        if (autotask !== null) {
            channels = this.getChannelsFromAutotask(autotask);

            for (let item of autotask.canisters) {
                canisters.push(getterHelper.getObjectById(this.props.canisterList, item));
            }

            if (autotask.runInterval !== null) {
                let days = Math.floor(autotask.runInterval / 86400);
                let hours = Math.floor((autotask.runInterval - days * 86400) / 3600);
                let minutes = Math.floor((autotask.runInterval - days * 86400 - hours * 3600) / 60);

                if (autotask.startType === autotaskTypes.START_TYPE_RUN_EVERY) {
                    let firstRun = this.calculateFirstRunDateFromInterval(
                        autotask.nextRun,
                        String(days),
                        String(hours),
                        String(minutes)
                    );

                    this.setState({
                        repeatIntervalValid: this.isRepeatIntervalValid(days, hours, minutes),
                        repeatDayInterval: String(days),
                        repeatHourInterval: String(hours),
                        repeatMinuteInterval: String(minutes),
                        firstRunEditable: false,
                        firstRun: firstRun,
                        firstRunDate: firstRun,
                        firstRunHour: String(firstRun.getHours()),
                        firstRunMinute: String(firstRun.getMinutes()),
                        firstRunSecond: String(firstRun.getSeconds())
                    });
                }

                if (
                    autotask.startType === autotaskTypes.START_TYPE_RUN_AT ||
                    autotask.startType === autotaskTypes.START_TYPE_DEFINED_DAYS_AT
                ) {
                    this.setState({
                        repeatIntervalValid: true,
                        repeatHourInterval: String(hours),
                        repeatMinuteInterval: String(minutes)
                    });
                }
            }
        }

        this.setState({channels: channels, canisters: canisters});
    }

    isRepeatIntervalValid = (days, hours, minutes) => {
        if (this.state.startType !== autotaskTypes.START_TYPE_RUN_EVERY) {
            return true;
        }

        return (
            (days === null ? Number(this.state.repeatDayInterval) : days) +
                (hours === null ? Number(this.state.repeatHourInterval) : hours) +
                (minutes === null ? Number(this.state.repeatMinuteInterval) : minutes) >
            0
        );
    };

    calculateFirstRunDateFromInterval = (date, days, hours, minutes) => {
        if (date !== null) {
            return new Date(date.getTime());
        }

        let firstRun = new Date().getTime();
        firstRun += Number(days === null ? this.state.repeatDayInterval : days) * 86400000;
        firstRun += Number(hours === null ? this.state.repeatHourInterval : hours) * 3600000;
        firstRun += Number(minutes === null ? this.state.repeatMinuteInterval : minutes) * 60000;

        return new Date(firstRun);
    };

    calculateFirstRunDate = (date, hours, minutes, seconds) => {
        let time = new Date(date === null ? this.state.firstRunDate.getTime() : date.getTime());

        time.setHours(Number(hours === null ? this.state.firstRunHour : hours));
        time.setMinutes(Number(minutes === null ? this.state.firstRunMinute : minutes));
        time.setSeconds(Number(seconds === null ? this.state.firstRunSecond : seconds));

        return time;
    };

    handleInputFocus = (event) => {
        event.target.select();
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseAutotaskModalAction();
    };

    handleActionTypeChange = (event) => {
        this.setState({
            actionType: Number(event.target.value),
            volume: rcc.RCC_DEFAULT_PURGE_VOLUME,
            channels: [],
            canisters: [],
            cleaningTime: this.props.cleaningTime,
            recirculationSpeed: this.props.recirculationSpeed,
            recirculationTime: this.props.recirculationTime,
            stirringSpeed: this.props.stirringSpeed,
            stirringTime: this.props.stirringTime
        });
    };

    handleNameChange = (event) => {
        this.setState({
            name: event.target.value
        });
    };

    handleStartTypeChange = (event) => {
        this.setState({
            startType: Number(event.target.value),
            repeatIntervalValid: Number(event.target.value) !== autotaskTypes.START_TYPE_RUN_EVERY,
            repeatDayInterval: "0",
            repeatHourInterval: "0",
            repeatMinuteInterval: "0",
            firstRunEditable: false,
            firstRun: null,
            firstRunHour: "0",
            firstRunMinute: "0",
            firstRunSecond: "0",
            selectedMonthDays: [],
            selectedWeekDays: [],
            monthDayInput: "",
            weekDayInput: "",
            activeDaysMultiselect: null
        });
    };

    handleRepeatDayIntervalChange = (event) => {
        if (validationHelper.isIntegerValueValid(event.target.value)) {
            this.setState({
                repeatDayInterval: event.target.value,
                firstRunEditable: false
            });
        }
    };

    handleRepeatDayIntervalBlur = (event) => {
        let days = event.target.value.trim().length === 0 ? 0 : Number(event.target.value);

        if (!isNaN(days)) {
            let firstRun = this.calculateFirstRunDateFromInterval(null, String(days), null, null);

            this.setState({
                repeatIntervalValid: this.isRepeatIntervalValid(days, null, null),
                repeatDayInterval: String(days),
                firstRunEditable: false,
                firstRun: firstRun,
                firstRunDate: firstRun,
                firstRunHour: String(firstRun.getHours()),
                firstRunMinute: String(firstRun.getMinutes()),
                firstRunSecond: String(firstRun.getSeconds())
            });
        }
    };

    handleRepeatHourIntervalChange = (event) => {
        if (validationHelper.isIntegerValueValid(event.target.value)) {
            this.setState({
                repeatHourInterval: event.target.value,
                firstRunEditable: false
            });
        }
    };

    handleRepeatHourIntervalBlur = (event) => {
        let hours = event.target.value.trim().length === 0 ? 0 : Number(event.target.value);

        if (!isNaN(hours)) {
            let validHours = hours < 24 ? event.target.value : "23";
            let firstRun = this.calculateFirstRunDateFromInterval(null, null, validHours, null);

            this.setState({
                repeatIntervalValid: this.isRepeatIntervalValid(null, hours, null),
                repeatHourInterval: validHours,
                firstRunEditable: false,
                firstRun: firstRun,
                firstRunDate: firstRun,
                firstRunHour: String(firstRun.getHours()),
                firstRunMinute: String(firstRun.getMinutes()),
                firstRunSecond: String(firstRun.getSeconds())
            });
        }
    };

    handleRepeatMinuteIntervalChange = (event) => {
        if (validationHelper.isIntegerValueValid(event.target.value)) {
            this.setState({
                repeatMinuteInterval: event.target.value,
                firstRunEditable: false
            });
        }
    };

    handleRepeatMinuteIntervalBlur = (event) => {
        let minutes = event.target.value.trim().length === 0 ? 0 : Number(event.target.value);

        if (!isNaN(minutes)) {
            let validMinutes = minutes < 60 ? event.target.value : "59";
            let firstRun = this.calculateFirstRunDateFromInterval(null, null, null, validMinutes);

            this.setState({
                repeatIntervalValid: this.isRepeatIntervalValid(null, null, minutes),
                repeatMinuteInterval: validMinutes,
                firstRunEditable: false,
                firstRun: firstRun,
                firstRunDate: firstRun,
                firstRunHour: String(firstRun.getHours()),
                firstRunMinute: String(firstRun.getMinutes()),
                firstRunSecond: String(firstRun.getSeconds())
            });
        }
    };

    handleEditFirstRunClick = () => {
        this.setState({
            firstRunEditable: true,
            firstRun: new Date()
        });
    };

    handleFirstRunDateClick = (date) => {
        this.setState({
            firstRun: this.calculateFirstRunDate(date, null, null, null),
            firstRunDate: date
        });
    };

    handleFirstRunHourChange = (event) => {
        if (validationHelper.isIntegerValueValid(event.target.value)) {
            this.setState({
                firstRunHour: event.target.value
            });
        }
    };

    handleFirstRunHourBlur = (event) => {
        let hours = event.target.value.trim().length === 0 ? 0 : Number(event.target.value);

        if (!isNaN(hours)) {
            let validHours = hours < 24 ? event.target.value : "23";

            this.setState({
                firstRun: this.calculateFirstRunDate(null, validHours, null, null),
                firstRunHour: validHours
            });
        }
    };

    handleFirstRunMinuteChange = (event) => {
        if (validationHelper.isIntegerValueValid(event.target.value)) {
            this.setState({
                firstRunMinute: event.target.value
            });
        }
    };

    handleFirstRunMinuteBlur = (event) => {
        let minutes = event.target.value.trim().length === 0 ? 0 : Number(event.target.value);

        if (!isNaN(minutes)) {
            let validMinutes = minutes < 60 ? event.target.value : "59";

            this.setState({
                firstRun: this.calculateFirstRunDate(null, null, validMinutes, null),
                firstRunMinute: validMinutes
            });
        }
    };

    handleFirstRunSecondChange = (event) => {
        if (validationHelper.isIntegerValueValid(event.target.value)) {
            this.setState({
                firstRunSecond: event.target.value
            });
        }
    };

    handleFirstRunSecondBlur = (event) => {
        let seconds = event.target.value.trim().length === 0 ? 0 : Number(event.target.value);

        if (!isNaN(seconds)) {
            let validSeconds = seconds < 60 ? event.target.value : "59";

            this.setState({
                firstRun: this.calculateFirstRunDate(null, null, null, validSeconds),
                firstRunSecond: validSeconds
            });
        }
    };

    handleEnabledChange = (event) => {
        this.setState({
            enabled: event.target.checked
        });
    };

    handleCanPostponeChange = (event) => {
        this.setState({
            canPostpone: event.target.checked
        });
    };

    handleVolumeChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                volume: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    handleChannelValueFocus = (event) => {
        event.target.select();
    };

    handleChannelValueBlur = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.changeChannelValue(
                Number(event.target.dataset.id),
                Number(validationHelper.formatDecimal(event.target.value))
            );
        }
    };

    handleChannelValueChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.changeChannelValue(
                Number(event.target.dataset.id),
                validationHelper.formatDecimal(event.target.value)
            );
        }
    };

    handleThresholdChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                threshold: event.target.value
            });
        }
    };

    handleThresholdBlur = (event) => {
        let value = Number(event.target.value);
        if (event.target.value !== "" && !isNaN(value) && value <= 100) {
            this.setState({
                threshold: value
            });
        } else {
            this.setState({
                threshold: formatHelper.convertDecimalToPercent(rcc.RCC_DEFAULT_AUTOTASK_THRESHOLD)
            });
        }
    };

    handleCleaningTimeChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                cleaningTime: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    handleCleaningTimeBlur = (event) => {
        let value = Number(event.target.value);

        if (!isNaN(value) && value >= rcc.RCC_MINIMAL_CLEAN_TIME) {
            this.setState({cleaningTime: formatHelper.formatDecimal(value)});
        } else {
            this.setState({cleaningTime: rcc.RCC_MINIMAL_CLEAN_TIME});
        }
    };

    handleRecirculationSpeedChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                recirculationSpeed: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    handleRecirculationSpeedBlur = (event) => {
        let value = Number(event.target.value);

        if (!isNaN(value) && value <= 100) {
            this.setState({recirculationSpeed: formatHelper.formatDecimal(value)});
        } else {
            this.setState({recirculationSpeed: this.props.recirculationSpeed});
        }
    };

    handleRecirculationTimeChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                recirculationTime: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    handleRecirculationTimeBlur = (event) => {
        let value = Number(event.target.value);

        if (!isNaN(value) && value >= rcc.RCC_MINIMAL_RECIRCULATE_TIME) {
            this.setState({recirculationTime: formatHelper.formatDecimal(value)});
        } else {
            this.setState({recirculationTime: rcc.RCC_MINIMAL_RECIRCULATE_TIME});
        }
    };

    handleStirringSpeedChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                stirringSpeed: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    handleStirringSpeedBlur = (event) => {
        let value = Number(event.target.value);

        if (!isNaN(value) && value <= 100) {
            this.setState({stirringSpeed: formatHelper.formatDecimal(value)});
        } else {
            this.setState({stirringSpeed: this.props.stirringSpeed});
        }
    };

    handleStirringTimeChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                stirringTime: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    handleStirringTimeBlur = (event) => {
        let value = Number(event.target.value);

        if (!isNaN(value) && value >= rcc.RCC_MINIMAL_STIR_TIME) {
            this.setState({stirringTime: formatHelper.formatDecimal(value)});
        } else {
            this.setState({stirringTime: rcc.RCC_MINIMAL_STIR_TIME});
        }
    };

    handleRemoveChannelClick = (event) => {
        let channel = this.getChannelFromSelectedList(Number(event.target.dataset.id));

        if (channel !== null) {
            this.setState({channels: this.getFilteredSelectedChannels(channel)});
        }
    };

    handleSelectChannelClick = (event) => {
        let channel = getterHelper.getObjectById(this.props.channelList, Number(event.target.dataset.id));

        if (channel !== null) {
            this.setState({
                channels: [...this.state.channels, channel]
            });
        }
    };

    handleCanisterClick = (event) => {
        let canister = getterHelper.getObjectById(this.props.canisterList, Number(event.target.dataset.id));

        if (canister !== null) {
            if (this.isCanisterSelected(canister)) {
                this.setState({
                    canisters: this.state.canisters.filter((selected) => selected.id !== canister.id)
                });
            } else {
                this.setState({
                    canisters: [...this.state.canisters, canister]
                });
            }
        }
    };

    handleSizeOfDiv = (type) => {
        window.jQuery("#fstQueryInput-" + type).on("input", function () {
            let value = window.jQuery(this).val();
            let size = value.length;
            size = size * 3;
            window.jQuery(this).css("width", size * 4);
        });
    };

    handleHelpClick = () => {
        this.props.dispatchOpenWebviewModalWithParams({
            link: config.HELP_ON_REDLIKE_AUTOTASKS,
            title: translate("help.help")
        });
    };

    getRunTime = () => {
        if (this.state.startType === autotaskTypes.START_TYPE_ON_START) {
            return null;
        }

        if (
            this.state.startType === autotaskTypes.START_TYPE_RUN_AT ||
            this.state.startType === autotaskTypes.START_TYPE_DEFINED_DAYS_AT
        ) {
            return Number(this.state.repeatHourInterval) * 3600 + Number(this.state.repeatMinuteInterval) * 60;
        }

        return (
            Number(this.state.repeatDayInterval) * 86400 +
            Number(this.state.repeatHourInterval) * 3600 +
            Number(this.state.repeatMinuteInterval) * 60
        );
    };

    getFirstRunTime = () => {
        if (
            this.state.startType !== autotaskTypes.START_TYPE_RUN_EVERY ||
            this.state.firstRun === null ||
            this.state.firstRunEditable === false
        ) {
            return null;
        }

        return new Date().getTime() > this.state.firstRun.getTime() ? null : this.state.firstRun;
    };

    handleAddClick = () => {
        let formula = [],
            channels = [],
            canisters = [];
        this.state.channels.map((channel) => formula.push({index: channel.id, volume: channel.volume}));
        this.state.channels.map((channel) => channels.push(channel.id));
        this.state.canisters.map((canister) => canisters.push(canister.id));

        let autotask = new Autotask(
            -1,
            this.state.name,
            this.state.actionType,
            this.state.startType,
            this.state.enabled,
            this.state.canPostpone,
            null,
            this.getFirstRunTime(),
            this.getRunTime(),
            this.state.selectedMonthDays,
            this.state.selectedWeekDays,
            null,
            Number(this.state.volume),
            formula,
            formatHelper.convertPercentToDecimal(this.state.threshold),
            canisters,
            Number(this.state.cleaningTime),
            channels,
            Number(this.state.recirculationTime),
            Number(this.state.recirculationSpeed),
            Number(this.state.stirringTime),
            Number(this.state.stirringSpeed)
        );

        this.props.dispatchAddAutotaskAction(autotask);
    };

    handleEditClick = () => {
        let formula = [],
            channels = [],
            canisters = [];
        this.state.channels.map((channel) => formula.push({index: channel.id, volume: channel.volume}));
        this.state.channels.map((channel) => channels.push(channel.id));
        this.state.canisters.map((canister) => canisters.push(canister.id));

        let autotask = new Autotask(
            this.state.id,
            this.state.name,
            this.state.actionType,
            this.state.startType,
            this.state.enabled,
            this.state.canPostpone,
            null,
            this.getFirstRunTime(),
            this.getRunTime(),
            this.state.selectedMonthDays,
            this.state.selectedWeekDays,
            null,
            Number(this.state.volume),
            formula,
            formatHelper.convertPercentToDecimal(this.state.threshold),
            canisters,
            Number(this.state.cleaningTime),
            channels,
            Number(this.state.recirculationTime),
            Number(this.state.recirculationSpeed),
            Number(this.state.stirringTime),
            Number(this.state.stirringSpeed)
        );

        this.props.dispatchUpdateAutotaskAction(autotask);
    };

    handleMonthDayInputChange = (event) => {
        this.setState({monthDayInput: event.target.value});
        this.handleSizeOfDiv(filtering.MONTH_DAYS);
    };

    handleWeekDayInputChange = (event) => {
        this.setState({weekDayInput: event.target.value});
        this.handleSizeOfDiv(filtering.WEEK_DAYS);
    };

    handleMonthDaySelectActive = () => {
        window.jQuery("#fstQueryInput-monthdays").focus();

        this.setState({
            activeDaysMultiselect:
                this.state.activeDaysMultiselect === filtering.MONTH_DAYS ? null : filtering.MONTH_DAYS
        });
    };

    handleMonthDayInputBlur = () => {
        this.setState({
            activeDaysMultiselect: null
        });
    };

    handleWeekDaySelectActive = () => {
        window.jQuery("#fstQueryInput-weekdays").focus();

        this.setState({
            activeDaysMultiselect: this.state.activeDaysMultiselect === filtering.WEEK_DAYS ? null : filtering.WEEK_DAYS
        });
    };

    handleWeekDayInputBlur = () => {
        this.setState({
            activeDaysMultiselect: null
        });
    };

    handleRemoveSelectedItem = (event) => {
        let itemType = event.currentTarget.dataset.type;
        let itemId = Number(event.currentTarget.dataset.id);

        if (itemType === filtering.MONTH_DAYS) {
            let newMonthDays = this.state.selectedMonthDays.filter((item) => item !== itemId);
            this.setState({selectedMonthDays: newMonthDays});
        }

        if (itemType === filtering.WEEK_DAYS) {
            let newWeekDays = this.state.selectedWeekDays.filter((item) => item !== itemId);
            this.setState({selectedWeekDays: newWeekDays});
        }
    };

    handleDeleteFilterInputs = (type) => {
        this.handleSizeOfDiv(type);
        switch (type) {
            case filtering.MONTH_DAYS:
                this.setState({monthDayInput: ""});
                break;
            case filtering.WEEK_DAYS:
                this.setState({weekDayInput: ""});
                break;
            default:
                break;
        }
    };

    handleSelectNameClick = (event) => {
        let itemId = Number(event.currentTarget.dataset.id);

        if (this.state.activeDaysMultiselect === filtering.MONTH_DAYS) {
            if (!this.state.selectedMonthDays.find((item) => item === itemId)) {
                let newMonthDays = this.state.selectedMonthDays.concat(itemId);
                this.setState({
                    selectedMonthDays: this.sortMultiselectArrays(newMonthDays),
                    activeDaysMultiselect: null
                });
                this.handleDeleteFilterInputs(filtering.MONTH_DAYS);
            }
        }

        if (this.state.activeDaysMultiselect === filtering.WEEK_DAYS) {
            if (!this.state.selectedWeekDays.find((item) => item === itemId)) {
                let newWeekDays = this.state.selectedWeekDays.concat(itemId);
                this.setState({selectedWeekDays: this.sortMultiselectArrays(newWeekDays), activeDaysMultiselect: null});
                this.handleDeleteFilterInputs(filtering.WEEK_DAYS);
            }
        }
    };

    sortMultiselectArrays = (array) => {
        return array.sort((a, b) => a - b);
    };

    changeChannelValue = (channelId, value) => {
        let changedChannel = this.getChannelFromSelectedList(channelId);

        if (changedChannel !== null) {
            changedChannel.volume = value;

            this.setState({
                channels: this.state.channels.map((channel) => {
                    if (channel.id === channelId) {
                        return changedChannel;
                    }

                    return channel;
                })
            });
        }
    };

    getChannelsFromAutotask = (autotask) => {
        let item,
            channel,
            newChannel,
            channels = [];

        switch (autotask.actionType) {
            case autotaskTypes.ACTION_TYPE_PURGE_FORMULA:
                for (item of autotask.formula) {
                    for (channel of this.props.channelList) {
                        if (channel.id === item.index) {
                            newChannel = channel.clone();
                            newChannel.volume = item.volume;
                            channels.push(newChannel);
                        }
                    }
                }
                return channels;
            case autotaskTypes.ACTION_TYPE_CLEAN_CHANNELS:
            case autotaskTypes.ACTION_TYPE_RECIRCULATE_CHANNELS:
            case autotaskTypes.ACTION_TYPE_SMART_PURGE_CHANNELS:
                for (item of autotask.channels) {
                    for (channel of this.props.channelList) {
                        if (channel.id === item) {
                            newChannel = channel.clone();
                            channels.push(newChannel);
                        }
                    }
                }
                return channels;
            default:
                return channels;
        }
    };

    getColorantByChannel = (channel) => {
        let colorant;
        for (colorant of this.props.colorantList) {
            if (channel.colorant.name === colorant.name) {
                return colorant;
            }
        }

        return null;
    };

    getCanisterRgb = (canister, colorant) => {
        if (canister !== null && canister.colorant !== null && canister.colorant.rgb !== null) {
            return canister.colorant.rgb;
        }

        if (colorant.rgb !== null) {
            return colorant.rgb;
        }

        return config.DEFAULT_RGB;
    };

    getColorantByCanister = (canister) => {
        let colorant;
        for (colorant of this.props.colorantList) {
            if (canister.colorant.name === colorant.name) {
                return colorant;
            }
        }

        return null;
    };

    getChannelFromSelectedList = (channelId) => {
        let selectedChannel;
        for (selectedChannel of this.state.channels) {
            if (selectedChannel.id === channelId) {
                return selectedChannel;
            }
        }

        return null;
    };

    getFilteredSelectedChannels = (filteredChannel) => {
        return this.state.channels.filter((channel) => channel.id !== filteredChannel.id);
    };

    isChannelSelected = (channel) => {
        if (this.state.channels.length === 0) {
            return false;
        }

        let selectedChannel;
        for (selectedChannel of this.state.channels) {
            if (selectedChannel.id === channel.id) {
                return true;
            }
        }

        return false;
    };

    isCanisterSelected = (canister) => {
        if (this.state.canisters.length === 0) {
            return false;
        }

        let selectedCanister;
        for (selectedCanister of this.state.canisters) {
            if (selectedCanister.id === canister.id) {
                return true;
            }
        }

        return false;
    };

    channelsValueValidation = () => {
        let channel;
        for (channel of this.state.channels) {
            if (Number(channel.volume) <= 0) {
                return false;
            }
        }

        return true;
    };

    getSelectedChannelRows = () => {
        let rows = [];

        let channel, colorant, rgb;
        for (channel of this.state.channels) {
            colorant = channel.colorant;
            if (colorant !== null && colorant.rgb === null) {
                colorant = this.getColorantByChannel(channel);
            }

            rgb = colorant !== null ? colorant.rgb : config.DEFAULT_RGB;

            rows.push(
                <div
                    key={channel.id}
                    className="col-12 flex flex-align-center-vertical padding-bottom-5 std-border-bottom"
                    style={{marginBottom: 5}}
                >
                    <div className="col-7 color-primary font-size-1_5em flex flex-align-center-vertical">
                        <div className="color-square" style={{backgroundColor: rgb, width: 15, height: 15}} />
                        <div>{colorant !== null ? colorant.displayName : ""}</div>
                    </div>
                    <div className="col-5 flex flex-align-center-vertical">
                        <Input
                            id={channel.id}
                            type="text"
                            className="primary-input col-10"
                            value={channel.volume}
                            elementProps={{
                                "data-id": channel.id
                            }}
                            onFocus={this.handleChannelValueFocus}
                            onBlur={this.handleChannelValueBlur}
                            onChange={this.handleChannelValueChange}
                            labelAfter={"ml"}
                        />
                        <div className="col-2 color-red text-center delete">
                            <span
                                className="glyphicon glyphicon-remove cursor-pointer"
                                data-id={channel.id}
                                onClick={this.handleRemoveChannelClick}
                            />
                        </div>
                    </div>
                </div>
            );
        }

        return rows;
    };

    getChannelBox = (channel) => {
        let colorant = channel.colorant;
        if (colorant !== null && colorant.rgb === null) {
            colorant = this.getColorantByChannel(channel);
        }

        let rgb = colorant !== null ? colorant.rgb : config.DEFAULT_RGB;

        if (!channel.enabled) {
            return (
                <div key={channel.id} className="general-colorant-select-box disabled">
                    <div className="general-colorant-select-box-id">{channel.id}</div>
                    <div className="general-colorant-select-box-color" style={{backgroundColor: rgb}} />
                    <div className="general-colorant-select-box-name">
                        {colorant !== null ? colorant.displayName : ""}
                    </div>
                </div>
            );
        }

        if (this.isChannelSelected(channel)) {
            return (
                <div
                    key={channel.id}
                    className="general-colorant-select-box disabled"
                    data-id={channel.id}
                    onClick={this.handleRemoveChannelClick}
                >
                    <div className="general-colorant-select-box-id" data-id={channel.id}>
                        {channel.id}
                    </div>
                    <div
                        className="general-colorant-select-box-color"
                        style={{backgroundColor: rgb}}
                        data-id={channel.id}
                    />
                    <div className="general-colorant-select-box-name" data-id={channel.id}>
                        {colorant !== null ? colorant.displayName : ""}
                    </div>
                </div>
            );
        }

        return (
            <div
                key={channel.id}
                className="general-colorant-select-box"
                data-id={channel.id}
                onClick={this.handleSelectChannelClick}
            >
                <div className="general-colorant-select-box-id" data-id={channel.id}>
                    {channel.id}
                </div>
                <div
                    className="general-colorant-select-box-color"
                    style={{backgroundColor: rgb}}
                    data-id={channel.id}
                />
                <div className="general-colorant-select-box-name" data-id={channel.id}>
                    {colorant !== null ? colorant.displayName : ""}
                </div>
            </div>
        );
    };

    getChannelBoxes = () => {
        let channels = [];

        let channel;
        for (channel of this.props.channelList) {
            channels.push(this.getChannelBox(channel));
        }

        return channels;
    };

    getCanisterBox = (canister) => {
        let colorant = canister.colorant;
        if (colorant !== null && colorant.rgb === null) {
            colorant = this.getColorantByCanister(canister);
        }

        let rgb = colorant !== null ? colorant.rgb : config.DEFAULT_RGB;

        if (!canister.enabled) {
            return (
                <div key={canister.id} className="general-colorant-select-box disabled">
                    <div className="general-colorant-select-box-id">{canister.name}</div>
                    <div className="general-colorant-select-box-color" style={{backgroundColor: rgb}} />
                    <div className="general-colorant-select-box-name">
                        {colorant !== null ? colorant.displayName : ""}
                    </div>
                </div>
            );
        }

        return (
            <div
                key={canister.id}
                className={"general-colorant-select-box" + (this.isCanisterSelected(canister) ? " disabled" : "")}
                data-id={canister.id}
                onClick={this.handleCanisterClick}
            >
                <div className="general-colorant-select-box-id" data-id={canister.id}>
                    {canister.name}
                </div>
                <div
                    className="general-colorant-select-box-color"
                    style={{backgroundColor: rgb}}
                    data-id={canister.id}
                />
                <div className="general-colorant-select-box-name" data-id={canister.id}>
                    {colorant !== null ? colorant.displayName : ""}
                </div>
            </div>
        );
    };

    getCanisterBoxes = () => {
        let canisters = [];

        let canister;
        for (canister of this.props.canisterList) {
            canisters.push(this.getCanisterBox(canister));
        }

        return canisters;
    };

    getModalTitle = () => {
        if (this.state.create) {
            return <Translate value="machineSettings.addAutotask" />;
        }

        return <Translate value="machineSettings.editAutotask" />;
    };

    getActionTypeOptions = () => {
        let item,
            options = [];

        options.push(
            <option key="header-1" className="color-primary uppercase" disabled>
                {translate("serviceActionsSettings.computer")}
            </option>
        );
        for (item of autotaskTypes.ACTION_TYPES_COMPUTER) {
            if (this.props.autotaskTypes.includes(item)) {
                switch (item) {
                    case autotaskTypes.ACTION_TYPE_COMPUTER_REBOOT:
                        options.push(
                            <option key={item} value={item}>
                                {translate("machineSettings.computerReboot")}
                            </option>
                        );
                        break;
                    case autotaskTypes.ACTION_TYPE_COMPUTER_SHUTDOWN:
                        options.push(
                            <option key={item} value={item}>
                                {translate("machineSettings.computerShutdown")}
                            </option>
                        );
                        break;
                    default:
                        break;
                }
            }
        }
        options.push(
            <option key="header-2" className="color-primary uppercase" disabled>
                {translate("serviceActionsSettings.serviceActions")}
            </option>
        );
        for (item of autotaskTypes.ACTION_TYPES_SERVICE_ACTIONS) {
            if (this.props.autotaskTypes.includes(item)) {
                switch (item) {
                    case autotaskTypes.ACTION_TYPE_PURGE_ALL:
                        options.push(
                            <option key={item} value={item}>
                                {translate("machineSettings.purgeAll")}
                            </option>
                        );
                        break;
                    case autotaskTypes.ACTION_TYPE_PURGE_FORMULA:
                        options.push(
                            <option key={item} value={item}>
                                {translate("serviceActionsSettings.purgeChannels")}
                            </option>
                        );
                        break;
                    case autotaskTypes.ACTION_TYPE_SMART_PURGE_ALL:
                        options.push(
                            <option key={item} value={item}>
                                {translate("machineSettings.smartPurgeAll")}
                            </option>
                        );
                        break;
                    case autotaskTypes.ACTION_TYPE_SMART_PURGE_CHANNELS:
                        options.push(
                            <option key={item} value={item}>
                                {translate("machineSettings.smartPurgeChannels")}
                            </option>
                        );
                        break;
                    case autotaskTypes.ACTION_TYPE_CLEAN_ALL:
                        options.push(
                            <option key={item} value={item}>
                                {translate("machineSettings.cleanAll")}
                            </option>
                        );
                        break;
                    case autotaskTypes.ACTION_TYPE_CLEAN_CHANNELS:
                        options.push(
                            <option key={item} value={item}>
                                {translate("serviceActionsSettings.cleanChannels")}
                            </option>
                        );
                        break;
                    case autotaskTypes.ACTION_TYPE_RECIRCULATE_ALL:
                        options.push(
                            <option key={item} value={item}>
                                {translate("machineSettings.recirculateAll")}
                            </option>
                        );
                        break;
                    case autotaskTypes.ACTION_TYPE_RECIRCULATE_CHANNELS:
                        options.push(
                            <option key={item} value={item}>
                                {translate("machineSettings.recirculateChannels")}
                            </option>
                        );
                        break;
                    case autotaskTypes.ACTION_TYPE_STIR_ALL:
                        options.push(
                            <option key={item} value={item}>
                                {translate("machineSettings.stirAll")}
                            </option>
                        );
                        break;
                    case autotaskTypes.ACTION_TYPE_STIR_CANISTERS:
                        options.push(
                            <option key={item} value={item}>
                                {translate("machineSettings.stirCanisters")}
                            </option>
                        );
                        break;
                    case autotaskTypes.ACTION_TYPE_REFILL_ALL_MAINTENANCE:
                        options.push(
                            <option key={item} value={item}>
                                {translate("machineSettings.refillAll")}
                            </option>
                        );
                        break;
                    case autotaskTypes.ACTION_TYPE_REFILL_CANISTERS_MAINTENANCE:
                        options.push(
                            <option key={item} value={item}>
                                {translate("machineSettings.refillCanisters")}
                            </option>
                        );
                        break;
                    default:
                        break;
                }
            }
        }

        options.push(
            <option key="header-3" className="color-primary uppercase" disabled>
                {translate("navigation.menu.maintenance")}
            </option>
        );
        for (item of autotaskTypes.ACTION_TYPES_MAINTENANCE) {
            if (this.props.autotaskTypes.includes(item)) {
                switch (item) {
                    case autotaskTypes.ACTION_TYPE_BRUSH_MAINTENANCE:
                        options.push(
                            <option key={item} value={item}>
                                {translate("machineSettings.brushMaintenance")}
                            </option>
                        );
                        break;
                    case autotaskTypes.ACTION_TYPE_CAP_MAINTENANCE:
                        options.push(
                            <option key={item} value={item}>
                                {translate("machineSettings.capMaintenance")}
                            </option>
                        );
                        break;
                    case autotaskTypes.ACTION_TYPE_SWITCH_PLATE_MAINTENANCE:
                        options.push(
                            <option key={item} value={item}>
                                {translate("machineSettings.switchPlateMaintenance")}
                            </option>
                        );
                        break;
                    case autotaskTypes.ACTION_TYPE_DISPENSER_CLEANING:
                        options.push(
                            <option key={item} value={item}>
                                {translate("machineSettings.dispenserCleaning")}
                            </option>
                        );
                        break;
                    case autotaskTypes.ACTION_TYPE_HUMIDIFIER_WATER_LEVEL_MAINTENANCE:
                        options.push(
                            <option key={item} value={item}>
                                {translate("machineSettings.humidifierWaterLevelMaintenance")}
                            </option>
                        );
                        break;
                    default:
                        break;
                }
            }
        }

        return options;
    };

    getHintTooltip = () => {
        if (this.props.activeHelp) {
            return (
                <ReactSVG
                    src={help}
                    alt="help"
                    data-text={translationHelper.getAutotaskHintTranslation(
                        this.state.actionType,
                        this.props.softwareName
                    )}
                    className="force-square size20x20 fit-image fill-primary pull-left margin-right-10"
                    onMouseEnter={tooltipHelper.createTooltip}
                />
            );
        }

        return "";
    };

    getActionTypeField = () => {
        if (this.state.create) {
            return (
                <div className="col-12 flex flex-align-center-vertical padding-bottom-10 std-border-bottom margin-bottom-10">
                    <div className="col-4">
                        {this.getHintTooltip()}
                        <Translate value="machineSettings.action" />
                        *:
                    </div>
                    <div className="col-8">
                        <select
                            className="primary-select col-12"
                            value={this.state.actionType}
                            onChange={this.handleActionTypeChange}
                        >
                            {this.getActionTypeOptions()}
                        </select>
                    </div>
                </div>
            );
        }

        let autoTaskName = "";
        switch (this.state.actionType) {
            case autotaskTypes.ACTION_TYPE_PURGE_ALL:
                autoTaskName = translate("machineSettings.purgeAll");
                break;
            case autotaskTypes.ACTION_TYPE_PURGE_FORMULA:
                autoTaskName = translate("serviceActionsSettings.purgeChannels");
                break;
            case autotaskTypes.ACTION_TYPE_SMART_PURGE_ALL:
                autoTaskName = translate("machineSettings.smartPurgeAll");
                break;
            case autotaskTypes.ACTION_TYPE_SMART_PURGE_CHANNELS:
                autoTaskName = translate("machineSettings.smartPurgeChannels");
                break;
            case autotaskTypes.ACTION_TYPE_CLEAN_ALL:
                autoTaskName = translate("machineSettings.cleanAll");
                break;
            case autotaskTypes.ACTION_TYPE_CLEAN_CHANNELS:
                autoTaskName = translate("serviceActionsSettings.cleanChannels");
                break;
            case autotaskTypes.ACTION_TYPE_RECIRCULATE_ALL:
                autoTaskName = translate("machineSettings.recirculateAll");
                break;
            case autotaskTypes.ACTION_TYPE_RECIRCULATE_CHANNELS:
                autoTaskName = translate("machineSettings.recirculateChannels");
                break;
            case autotaskTypes.ACTION_TYPE_STIR_ALL:
                autoTaskName = translate("machineSettings.stirAll");
                break;
            case autotaskTypes.ACTION_TYPE_STIR_CANISTERS:
                autoTaskName = translate("machineSettings.stirCanisters");
                break;
            case autotaskTypes.ACTION_TYPE_BRUSH_MAINTENANCE:
                autoTaskName = translate("machineSettings.brushMaintenance");
                break;
            case autotaskTypes.ACTION_TYPE_CAP_MAINTENANCE:
                autoTaskName = translate("machineSettings.capMaintenance");
                break;
            case autotaskTypes.ACTION_TYPE_SWITCH_PLATE_MAINTENANCE:
                autoTaskName = translate("machineSettings.switchPlateMaintenance");
                break;
            case autotaskTypes.ACTION_TYPE_DISPENSER_CLEANING:
                autoTaskName = translate("machineSettings.dispenserCleaning");
                break;
            case autotaskTypes.ACTION_TYPE_HUMIDIFIER_WATER_LEVEL_MAINTENANCE:
                autoTaskName = translate("machineSettings.humidifierWaterLevelMaintenance");
                break;
            case autotaskTypes.ACTION_TYPE_REFILL_ALL_MAINTENANCE:
                autoTaskName = translate("machineSettings.refillAll");
                break;
            case autotaskTypes.ACTION_TYPE_REFILL_CANISTERS_MAINTENANCE:
                autoTaskName = translate("machineSettings.refillCanisters");
                break;
            case autotaskTypes.ACTION_TYPE_COMPUTER_REBOOT:
                autoTaskName = translate("machineSettings.computerReboot");
                break;
            case autotaskTypes.ACTION_TYPE_COMPUTER_SHUTDOWN:
                autoTaskName = translate("machineSettings.computerShutdown");
                break;
            default:
                return "";
        }

        return (
            <div className="col-12 flex flex-align-center-vertical padding-bottom-10 std-border-bottom margin-bottom-10">
                <div className="col-4">
                    {this.getHintTooltip()}
                    <Translate value="machineSettings.action" />
                </div>
                <div className="col-8">{autoTaskName}</div>
            </div>
        );
    };

    getNameField = (key) => {
        return (
            <div key={key} className="col-12 flex flex-align-center-vertical padding-bottom-10">
                <div className="col-4">
                    <Translate value="general.nameTitle" />
                    *:
                </div>
                <Input
                    className="primary-input col-8"
                    type="text"
                    value={this.state.name}
                    onChange={this.handleNameChange}
                />
            </div>
        );
    };

    getMonthDaysActiveItems = () => {
        let item,
            itemsList = [];

        for (item of this.state.selectedMonthDays) {
            itemsList.push(
                <div key={item} className="fstChoiceItem">
                    {item}.
                    <button
                        className="fstChoiceRemove"
                        type="button"
                        data-type={filtering.MONTH_DAYS}
                        data-id={item}
                        value={item}
                        onClick={this.handleRemoveSelectedItem}
                    >
                        Ã
                    </button>
                </div>
            );
        }
        return itemsList;
    };

    getWeekDaysActiveItems = () => {
        let item,
            itemsList = [];

        for (item of this.state.selectedWeekDays) {
            itemsList.push(
                <div key={item} className="fstChoiceItem">
                    {translationHelper.getWeekDaysTranslations(item)}
                    <button
                        className="fstChoiceRemove"
                        type="button"
                        data-type={filtering.WEEK_DAYS}
                        data-id={item}
                        value={item}
                        onClick={this.handleRemoveSelectedItem}
                    >
                        Ã
                    </button>
                </div>
            );
        }
        return itemsList;
    };

    isSelectActive = (selectName) => {
        switch (selectName) {
            case filtering.MONTH_DAYS:
                if (this.state.activeDaysMultiselect === filtering.MONTH_DAYS) {
                    return "select-box-list monthdays active";
                }
                return "select-box-list monthdays";
            case filtering.WEEK_DAYS:
                if (this.state.activeDaysMultiselect === filtering.WEEK_DAYS) {
                    return "select-box-list weekdays active";
                }
                return "select-box-list weekdays";
            default:
                return "";
        }
    };

    getMonthDaysSelectBox = (defaultItemList, selectedItemList, inputName) => {
        let itemList = [];
        for (let item of defaultItemList) {
            let alreadySelected = selectedItemList.includes(item);
            if (
                (inputName === "" || item.toString().toLowerCase().includes(inputName.toLowerCase())) &&
                !alreadySelected
            ) {
                itemList.push(
                    <li className="select-box-item" key={item} data-id={item} onMouseDown={this.handleSelectNameClick}>
                        {item}.
                    </li>
                );
            }
        }
        return itemList;
    };

    getWeekDaysSelectBox = (defaultItemList, selectedItemList, inputName) => {
        let itemList = [];
        for (let item of defaultItemList) {
            let alreadySelected = selectedItemList.includes(item);
            if (
                (inputName === "" ||
                    translationHelper.getWeekDaysTranslations(item).toLowerCase().includes(inputName.toLowerCase())) &&
                !alreadySelected
            ) {
                itemList.push(
                    <li className="select-box-item" key={item} data-id={item} onMouseDown={this.handleSelectNameClick}>
                        {translationHelper.getWeekDaysTranslations(item)}
                    </li>
                );
            }
        }
        return itemList;
    };

    getFirstRunLabel = () => {
        if (this.state.create) {
            return <Translate value="machineSettings.firstRun" />;
        }

        return <Translate value="machineSettings.nextRun" />;
    };

    getFirstRunEditButton = () => {
        if (this.state.repeatIntervalValid) {
            return (
                <a className="cursor-pointer margin-left-10" href="# " onClick={this.handleEditFirstRunClick}>
                    <Translate value="general.edit" />
                </a>
            );
        }

        return null;
    };

    getFirstRunForm = () => {
        if (!this.state.firstRunEditable) {
            return (
                <div className="col-12 flex">
                    <div className="col-2 ">{this.getFirstRunLabel()}:</div>
                    <div className="col-6">
                        {this.state.firstRun !== null && this.state.repeatIntervalValid
                            ? formatHelper.formatDateTime(this.state.firstRun)
                            : "-"}
                        {this.getFirstRunEditButton()}
                    </div>
                </div>
            );
        }

        return (
            <React.Fragment>
                <div className="col-12">
                    <div className="col-2">{this.getFirstRunLabel()}:</div>
                    <div className="col-11 padding-bottom-10">
                        <Calendar
                            onClickDay={this.handleFirstRunDateClick}
                            maxDate={null}
                            minDate={new Date()}
                            value={this.state.firstRunDate}
                            locale={this.props.language}
                            minDetail="year"
                        />
                    </div>
                </div>
                <div className="col-12 flex">
                    <Input
                        className="primary-input col-3 margin-right-5"
                        type="text"
                        value={this.state.firstRunHour}
                        onFocus={this.handleInputFocus}
                        onChange={this.handleFirstRunHourChange}
                        onBlur={this.handleFirstRunHourBlur}
                        labelAfter={<Translate value="general.hours" />}
                    />
                    <Input
                        className="primary-input col-3 margin-right-5"
                        type="text"
                        value={this.state.firstRunMinute}
                        onFocus={this.handleInputFocus}
                        onChange={this.handleFirstRunMinuteChange}
                        onBlur={this.handleFirstRunMinuteBlur}
                        labelAfter={<Translate value="general.minutes" />}
                    />
                    <Input
                        className="primary-input col-3"
                        type="text"
                        value={this.state.firstRunSecond}
                        onFocus={this.handleInputFocus}
                        onChange={this.handleFirstRunSecondChange}
                        onBlur={this.handleFirstRunSecondBlur}
                        labelAfter={<Translate value="general.seconds" />}
                    />
                </div>
            </React.Fragment>
        );
    };

    getRunIntervalField = () => {
        if (this.state.startType === autotaskTypes.START_TYPE_ON_START) {
            return "";
        }

        if (this.state.startType === autotaskTypes.START_TYPE_RUN_AT) {
            return (
                <div className="col-6 flex padding-top-10">
                    <div className="col-6 flex flex-align-center-vertical">
                        <Translate className="col-6 text-right" value="machineSettings.hours" />:
                        <Input
                            type="text"
                            className="primary-input col-6 margin-left-5"
                            value={this.state.repeatHourInterval}
                            placeholder={translate("machineSettings.hours")}
                            onChange={this.handleRepeatHourIntervalChange}
                            onBlur={this.handleRepeatHourIntervalBlur}
                            onFocus={this.handleInputFocus}
                        />
                    </div>
                    <div className="col-6 flex flex-align-center-vertical margin-left-5">
                        <Translate className="col-6 text-right" value="machineSettings.minutes" />:
                        <Input
                            type="text"
                            className="primary-input col-6 margin-left-5"
                            value={this.state.repeatMinuteInterval}
                            placeholder={translate("machineSettings.minutes")}
                            onChange={this.handleRepeatMinuteIntervalChange}
                            onBlur={this.handleRepeatMinuteIntervalBlur}
                            onFocus={this.handleInputFocus}
                        />
                    </div>
                </div>
            );
        }

        if (this.state.startType === autotaskTypes.START_TYPE_DEFINED_DAYS_AT) {
            return (
                <div className="col-12 flex flex-wrap padding-top-10">
                    <div className="flex flex-align-center-vertical col-12">
                        <div className="col-4">
                            <Translate value="machineSettings.daysOfMonth" />:
                        </div>
                        <div
                            className="fstMultipleMode select-box primary-select col-8 margin-left-5"
                            id="div-box-monthdays"
                            onClick={this.handleMonthDaySelectActive}
                        >
                            {this.getMonthDaysActiveItems()}
                            <input
                                id="fstQueryInput-monthdays"
                                className="fstQueryInput col-11"
                                style={{border: "none"}}
                                type="text"
                                value={this.state.monthDayInput}
                                onFocus={this.handleInputFocus}
                                onChange={this.handleMonthDayInputChange}
                                onBlur={this.handleMonthDayInputBlur}
                            />
                            <div
                                id="autotask-filters-monthdays"
                                style={{width: "50%"}}
                                className={this.isSelectActive(filtering.MONTH_DAYS)}
                            >
                                <ul className="slim-scroll ">
                                    {this.getMonthDaysSelectBox(
                                        autotaskTypes.DAYS_OF_MONTH,
                                        this.state.selectedMonthDays,
                                        this.state.monthDayInput
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-align-center-vertical col-12">
                        <div className="col-4">
                            <Translate value="machineSettings.weekdays" />:
                        </div>
                        <div
                            className="fstMultipleMode select-box primary-select col-8 margin-left-5"
                            id="div-box-weekdays"
                            onClick={this.handleWeekDaySelectActive}
                        >
                            {this.getWeekDaysActiveItems()}
                            <input
                                id="fstQueryInput-weekdays"
                                className="fstQueryInput col-11"
                                style={{border: "none"}}
                                type="text"
                                value={this.state.weekDayInput}
                                onFocus={this.handleInputFocus}
                                onChange={this.handleWeekDayInputChange}
                                onBlur={this.handleWeekDayInputBlur}
                            />
                            <div
                                id="autotask-filters-weekdays"
                                style={{width: "50%"}}
                                className={this.isSelectActive(filtering.WEEK_DAYS)}
                            >
                                <ul className="slim-scroll ">
                                    {this.getWeekDaysSelectBox(
                                        autotaskTypes.WEEKDAYS,
                                        this.state.selectedWeekDays,
                                        this.state.weekDayInput
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-8 flex flex-align-center-vertical ">
                        <Translate value="machineSettings.hours" />:
                        <Input
                            type="text"
                            className="hours-minutes col-2 primary-input margin-left-5"
                            value={this.state.repeatHourInterval}
                            placeholder={translate("machineSettings.hours")}
                            onFocus={this.handleInputFocus}
                            onChange={this.handleRepeatHourIntervalChange}
                            onBlur={this.handleRepeatHourIntervalBlur}
                        />
                        <Translate className="text-right margin-left-5" value="machineSettings.minutes" />:
                        <Input
                            type="text"
                            className="hours-minutes col-2 primary-input margin-left-5"
                            value={this.state.repeatMinuteInterval}
                            placeholder={translate("machineSettings.minutes")}
                            onFocus={this.handleInputFocus}
                            onChange={this.handleRepeatMinuteIntervalChange}
                            onBlur={this.handleRepeatMinuteIntervalBlur}
                        />
                    </div>
                </div>
            );
        }

        return (
            <div className="col-12 flex flex-wrap padding-top-10">
                <div className="col-3">
                    <Translate value="machineSettings.runEvery" />:
                </div>
                <div className="col-9 flex padding-bottom-10">
                    <div className="col-3 flex flex-align-center-vertical">
                        <Translate value="machineSettings.days" />:
                        <Input
                            type="text"
                            className="hours-minutes primary-input col-5 margin-left-5"
                            value={this.state.repeatDayInterval}
                            placeholder={translate("machineSettings.days")}
                            onChange={this.handleRepeatDayIntervalChange}
                            onBlur={this.handleRepeatDayIntervalBlur}
                            onFocus={this.handleInputFocus}
                        />
                    </div>
                    <div className="col-3 flex flex-align-center-vertical">
                        <Translate value="machineSettings.hours" />:
                        <Input
                            type="text"
                            className="hours-minutes primary-input col-5 margin-left-5"
                            value={this.state.repeatHourInterval}
                            placeholder={translate("machineSettings.hours")}
                            onChange={this.handleRepeatHourIntervalChange}
                            onBlur={this.handleRepeatHourIntervalBlur}
                            onFocus={this.handleInputFocus}
                        />
                    </div>
                    <div className="col-3 flex flex-align-center-vertical">
                        <Translate value="machineSettings.minutes" />:
                        <Input
                            type="text"
                            className="hours-minutes primary-input col-5 margin-left-5"
                            value={this.state.repeatMinuteInterval}
                            placeholder={translate("machineSettings.minutes")}
                            onChange={this.handleRepeatMinuteIntervalChange}
                            onBlur={this.handleRepeatMinuteIntervalBlur}
                            onFocus={this.handleInputFocus}
                        />
                    </div>
                </div>
                {this.getFirstRunForm()}
            </div>
        );
    };

    getStartTypeField = (key) => {
        return (
            <div key={key} className="col-12 flex padding-bottom-10">
                <div className="col-4">
                    <Translate value="machineSettings.startType" />
                    *:
                </div>
                <div className="col-8 flex flex-wrap">
                    <select
                        className="col-12 primary-select"
                        value={this.state.startType}
                        onChange={this.handleStartTypeChange}
                    >
                        <option value={autotaskTypes.START_TYPE_ON_START}>
                            {translate("machineSettings.onStart")}
                        </option>
                        <option value={autotaskTypes.START_TYPE_RUN_AT}>{translate("machineSettings.runAt")}</option>
                        <option value={autotaskTypes.START_TYPE_DEFINED_DAYS_AT}>
                            {translate("machineSettings.runDefinedDaysAt")}
                        </option>
                        <option value={autotaskTypes.START_TYPE_RUN_EVERY}>
                            {translate("machineSettings.runEvery")}
                        </option>
                    </select>
                    {this.getRunIntervalField()}
                </div>
            </div>
        );
    };

    getEnabledField = (key) => {
        return (
            <div key={key} className="col-12 flex padding-bottom-10">
                <div className="col-4">
                    <Translate value="general.enabled" />:
                </div>
                <div className="col-8">
                    <label className="checkbox-style-light">
                        <input
                            type="checkbox"
                            className="checkbox"
                            checked={this.state.enabled}
                            onChange={this.handleEnabledChange}
                        />
                        <span className="checkmark" />
                    </label>
                </div>
            </div>
        );
    };

    getCanPostponeField = (key) => {
        return (
            <div key={key} className="col-12 flex padding-bottom-10">
                <div className="col-4">
                    <Translate value="machineSettings.postpone" />:
                </div>
                <div className="col-8">
                    <label className="checkbox-style-light">
                        <input
                            type="checkbox"
                            className="checkbox"
                            checked={this.state.canPostpone}
                            onChange={this.handleCanPostponeChange}
                        />
                        <span className="checkmark" />
                    </label>
                </div>
            </div>
        );
    };

    getVolumeField = (key) => {
        return (
            <div key={key} className="col-12 flex padding-bottom-10">
                <div className="col-4">
                    <Translate value="machineSettings.volume" />
                    *:
                </div>
                <Input
                    className="primary-input col-8"
                    type="text"
                    value={this.state.volume}
                    onChange={this.handleVolumeChange}
                    labelAfter={settings.UNIT_ML}
                />
            </div>
        );
    };

    getFormulaField = (key) => {
        return (
            <div key={key} className="height-10vh slim-scroll">
                {this.getSelectedChannelRows()}
            </div>
        );
    };

    getChannelsField = (key) => {
        return (
            <div key={key} className="height-50per general-wrapper">
                <div className="general-wrapper-body slim-scroll general-colorant-select-box-wrapper">
                    {this.getChannelBoxes()}
                </div>
            </div>
        );
    };

    getThresholdField = (key) => {
        return (
            <div key={key} className="col-12 flex padding-bottom-10">
                <div className="col-4">
                    <Translate value="machineSettings.threshold" />
                    *:
                </div>
                <Input
                    className="primary-input col-8"
                    type="text"
                    value={this.state.threshold}
                    onChange={this.handleThresholdChange}
                    onBlur={this.handleThresholdBlur}
                    labelAfter={"%"}
                />
            </div>
        );
    };

    getCanistersField = (key) => {
        return (
            <div key={key} className="height-50per general-wrapper">
                <div className="general-wrapper-body slim-scroll general-colorant-select-box-wrapper">
                    {this.getCanisterBoxes()}
                </div>
            </div>
        );
    };

    getCleaningTimeField = (key) => {
        return (
            <div key={key} className="col-12 flex padding-bottom-10">
                <div className="col-4">
                    <Translate value="cleanChannels.cleaningTime" />
                    *:
                </div>
                <Input
                    className="primary-input col-8"
                    type="text"
                    value={this.state.cleaningTime}
                    onChange={this.handleCleaningTimeChange}
                    onBlur={this.handleCleaningTimeBlur}
                    labelAfter={settings.SECONDS}
                />
            </div>
        );
    };

    getRecirculationTimeField = (key) => {
        return (
            <div key={key} className="col-12 flex padding-bottom-10">
                <div className="col-4">
                    <Translate value="machineSettings.recirculationTime" />
                    *:
                </div>
                <Input
                    className="primary-input col-8"
                    type="text"
                    value={this.state.recirculationTime}
                    onChange={this.handleRecirculationTimeChange}
                    onBlur={this.handleRecirculationTimeBlur}
                    labelAfter={settings.SECONDS}
                />
            </div>
        );
    };

    getRecirculationSpeedField = (key) => {
        return (
            <div key={key} className="col-12 flex padding-bottom-10">
                <div className="col-4">
                    <Translate value="machineSettings.recirculationSpeed" />
                    *:
                </div>
                <Input
                    className="primary-input col-8"
                    type="text"
                    value={this.state.recirculationSpeed}
                    onChange={this.handleRecirculationSpeedChange}
                    onBlur={this.handleRecirculationSpeedBlur}
                    labelAfter={"%"}
                />
            </div>
        );
    };

    getStirringTimeField = (key) => {
        return (
            <div key={key} className="col-12 flex padding-bottom-10">
                <div className="col-4">
                    <Translate value="machineSettings.stirringTime" />
                    *:
                </div>
                <Input
                    className="primary-input col-8"
                    type="text"
                    value={this.state.stirringTime}
                    onChange={this.handleStirringTimeChange}
                    onBlur={this.handleStirringTimeBlur}
                    labelAfter={settings.SECONDS}
                />
            </div>
        );
    };

    getStirringSpeedField = (key) => {
        return (
            <div key={key} className="col-12 flex padding-bottom-10">
                <div className="col-4">
                    <Translate value="machineSettings.stirringSpeed" />
                    *:
                </div>
                <Input
                    className="primary-input col-8"
                    type="text"
                    value={this.state.stirringSpeed}
                    onChange={this.handleStirringSpeedChange}
                    onBlur={this.handleStirringSpeedBlur}
                    labelAfter={"%"}
                />
            </div>
        );
    };

    getPurgeAllForm = () => {
        return [
            this.getNameField(1),
            this.getVolumeField(2),
            this.getStartTypeField(3),
            this.getCanPostponeField(4),
            this.getEnabledField(5)
        ];
    };

    getPurgeFormulaForm = () => {
        return [
            this.getNameField(1),
            this.getStartTypeField(2),
            this.getCanPostponeField(3),
            this.getEnabledField(4),
            this.getChannelsField(5),
            this.getFormulaField(6)
        ];
    };

    getRefillAllForm = () => {
        return [
            this.getNameField(1),
            this.getThresholdField(2),
            this.getStartTypeField(3),
            this.getCanPostponeField(4),
            this.getEnabledField(5)
        ];
    };

    getRefillCanistersForm = () => {
        return [
            this.getNameField(1),
            this.getThresholdField(2),
            this.getStartTypeField(3),
            this.getCanPostponeField(4),
            this.getEnabledField(5),
            this.getCanistersField(6)
        ];
    };

    getCleanAllForm = () => {
        return [
            this.getNameField(1),
            this.getCleaningTimeField(2),
            this.getStartTypeField(3),
            this.getCanPostponeField(4),
            this.getEnabledField(5)
        ];
    };

    getCleanChannelsForm = () => {
        return [
            this.getNameField(1),
            this.getCleaningTimeField(2),
            this.getStartTypeField(3),
            this.getCanPostponeField(4),
            this.getEnabledField(5),
            this.getChannelsField(6)
        ];
    };

    getRecirculateAllForm = () => {
        return [
            this.getNameField(1),
            this.getRecirculationTimeField(2),
            this.getRecirculationSpeedField(3),
            this.getStartTypeField(4),
            this.getCanPostponeField(5),
            this.getEnabledField(6)
        ];
    };

    getRecirculationChannelsForm = () => {
        return [
            this.getNameField(1),
            this.getRecirculationTimeField(2),
            this.getRecirculationSpeedField(3),
            this.getStartTypeField(4),
            this.getCanPostponeField(5),
            this.getEnabledField(6),
            this.getChannelsField(7)
        ];
    };

    getStirAllForm = () => {
        return [
            this.getNameField(1),
            this.getStirringTimeField(2),
            this.getStirringSpeedField(3),
            this.getStartTypeField(4),
            this.getCanPostponeField(5),
            this.getEnabledField(6)
        ];
    };

    getStirCanistersForm = () => {
        return [
            this.getNameField(1),
            this.getStirringTimeField(2),
            this.getStirringSpeedField(3),
            this.getStartTypeField(4),
            this.getCanPostponeField(5),
            this.getEnabledField(6),
            this.getCanistersField(7)
        ];
    };

    getSmartPurgeChannelsForm = () => {
        return [
            this.getNameField(1),
            this.getStartTypeField(2),
            this.getCanPostponeField(3),
            this.getEnabledField(4),
            this.getChannelsField(5)
        ];
    };

    getDefaultForm = () => {
        return [this.getNameField(1), this.getStartTypeField(2), this.getCanPostponeField(3), this.getEnabledField(4)];
    };

    getAutotaskForm = () => {
        switch (this.state.actionType) {
            case autotaskTypes.ACTION_TYPE_PURGE_ALL:
                return this.getPurgeAllForm();
            case autotaskTypes.ACTION_TYPE_PURGE_FORMULA:
                return this.getPurgeFormulaForm();
            case autotaskTypes.ACTION_TYPE_SMART_PURGE_CHANNELS:
                return this.getSmartPurgeChannelsForm();
            case autotaskTypes.ACTION_TYPE_REFILL_ALL_MAINTENANCE:
                return this.getRefillAllForm();
            case autotaskTypes.ACTION_TYPE_REFILL_CANISTERS_MAINTENANCE:
                return this.getRefillCanistersForm();
            case autotaskTypes.ACTION_TYPE_CLEAN_ALL:
                return this.getCleanAllForm();
            case autotaskTypes.ACTION_TYPE_CLEAN_CHANNELS:
                return this.getCleanChannelsForm();
            case autotaskTypes.ACTION_TYPE_RECIRCULATE_ALL:
                return this.getRecirculateAllForm();
            case autotaskTypes.ACTION_TYPE_RECIRCULATE_CHANNELS:
                return this.getRecirculationChannelsForm();
            case autotaskTypes.ACTION_TYPE_STIR_ALL:
                return this.getStirAllForm();
            case autotaskTypes.ACTION_TYPE_STIR_CANISTERS:
                return this.getStirCanistersForm();
            default:
                return this.getDefaultForm();
        }
    };

    isPurgeAllFormValid = () => {
        if (this.state.volume === "") {
            return false;
        }

        return true;
    };

    isPurgeFormulaFormValid = () => {
        if (this.state.channels.length > 0 && this.channelsValueValidation()) {
            return true;
        }

        return false;
    };

    isRefillColorantsFormValid = () => {
        if (this.state.canisters.length > 0) {
            return true;
        }

        return false;
    };

    isCleanAllFormValid = () => {
        if (this.state.cleaningTime === "") {
            return false;
        }

        return true;
    };

    isCleanChannelsFormValid = () => {
        if (this.state.cleaningTime === "") {
            return false;
        }

        if (this.state.channels.length === 0) {
            return false;
        }

        return true;
    };

    isRecirculateAllFormValid = () => {
        if (this.state.recirculationTime === "" || this.state.recirculationSpeed === "") {
            return false;
        }

        return true;
    };

    isRecirculateChannelsFormValid = () => {
        if (this.state.recirculationTime === "" || this.state.recirculationSpeed === "") {
            return false;
        }

        if (this.state.channels.length === 0) {
            return false;
        }

        return true;
    };

    isStirAllFormValid = () => {
        if (this.state.stirringTime === "" || this.state.stirringSpeed === "") {
            return false;
        }

        return true;
    };

    isStirCanistersFormValid = () => {
        if (this.state.stirringTime === "" || this.state.stirringSpeed === "") {
            return false;
        }

        if (this.state.canisters.length === 0) {
            return false;
        }

        return true;
    };

    isSmartPurgeChannelsFormValid = () => {
        if (this.state.channels.length === 0) {
            return false;
        }

        return true;
    };

    isValid = () => {
        if (this.state.actionType === "") {
            return false;
        }

        if (this.state.name === "") {
            return false;
        }

        if (!this.state.repeatIntervalValid) {
            return false;
        }

        switch (this.state.actionType) {
            case autotaskTypes.ACTION_TYPE_PURGE_ALL:
                return this.isPurgeAllFormValid();
            case autotaskTypes.ACTION_TYPE_PURGE_FORMULA:
                return this.isPurgeFormulaFormValid();
            case autotaskTypes.ACTION_TYPE_SMART_PURGE_CHANNELS:
                return this.isSmartPurgeChannelsFormValid();
            case autotaskTypes.ACTION_TYPE_REFILL_CANISTERS_MAINTENANCE:
                return this.isRefillColorantsFormValid();
            case autotaskTypes.ACTION_TYPE_CLEAN_ALL:
                return this.isCleanAllFormValid();
            case autotaskTypes.ACTION_TYPE_CLEAN_CHANNELS:
                return this.isCleanChannelsFormValid();
            case autotaskTypes.ACTION_TYPE_RECIRCULATE_ALL:
                return this.isRecirculateAllFormValid();
            case autotaskTypes.ACTION_TYPE_RECIRCULATE_CHANNELS:
                return this.isRecirculateChannelsFormValid();
            case autotaskTypes.ACTION_TYPE_STIR_ALL:
                return this.isStirAllFormValid();
            case autotaskTypes.ACTION_TYPE_STIR_CANISTERS:
                return this.isStirCanistersFormValid();
            default:
                return true;
        }
    };

    getConfirmBtnTooltipText = () => {
        if (this.state.name === "") {
            return translate("help.machineSettings.missingAutotaskName");
        }
        switch (this.state.actionType) {
            case autotaskTypes.ACTION_TYPE_PURGE_ALL:
                if (this.state.volume === "") {
                    return translate("help.machineSettings.missingAutotaskVolume");
                }
                break;
            case autotaskTypes.ACTION_TYPE_PURGE_FORMULA:
                if (this.state.channels.length === 0) {
                    return translate("help.machineSettings.missingAutotaskChannels");
                }
                if (this.state.channels.length > 0 && !this.channelsValueValidation()) {
                    return translate("help.machineSettings.missingAutotaskChannelsValue");
                }
                break;
            case autotaskTypes.ACTION_TYPE_SMART_PURGE_CHANNELS:
                if (this.state.channels.length === 0) {
                    return translate("help.machineSettings.missingAutotaskChannels");
                }
                break;
            case autotaskTypes.ACTION_TYPE_REFILL_CANISTERS_MAINTENANCE:
                if (this.state.canisters.length === 0) {
                    return translate("help.machineSettings.missingAutotaskCanisters");
                }
                break;
            case autotaskTypes.ACTION_TYPE_CLEAN_ALL:
                if (this.state.cleaningTime === "") {
                    return translate("help.machineSettings.missingAutotaskCleanTime");
                }
                break;
            case autotaskTypes.ACTION_TYPE_CLEAN_CHANNELS:
                if (this.state.cleaningTime === "") {
                    return translate("help.machineSettings.missingAutotaskCleanTime");
                }
                if (this.state.channels.length === 0) {
                    return translate("help.machineSettings.missingAutotaskChannels");
                }
                break;
            case autotaskTypes.ACTION_TYPE_RECIRCULATE_ALL:
                if (this.state.recirculationTime === "" || this.state.recirculationSpeed === "") {
                    return translate("help.machineSettings.missingAutotaskRecirculation");
                }
                break;
            case autotaskTypes.ACTION_TYPE_RECIRCULATE_CHANNELS:
                if (this.state.recirculationTime === "" || this.state.recirculationSpeed === "") {
                    return translate("help.machineSettings.missingAutotaskRecirculation");
                }
                if (this.state.channels.length === 0) {
                    return translate("help.machineSettings.missingAutotaskChannels");
                }
                break;
            case autotaskTypes.ACTION_TYPE_STIR_ALL:
                if (this.state.stirringTime === "" || this.state.stirringSpeed === "") {
                    return translate("help.machineSettings.missingAutotaskStirring");
                }
                break;
            case autotaskTypes.ACTION_TYPE_STIR_CANISTERS:
                if (this.state.stirringTime === "" || this.state.stirringSpeed === "") {
                    return translate("help.machineSettings.missingAutotaskStirring");
                }
                if (this.state.canisters.length === 0) {
                    return translate("help.machineSettings.missingAutotaskCanisters");
                }
                break;
            default:
                return translate("general.missingRequiredItems");
        }
        return translate("general.missingRequiredItems");
    };

    getHelpButton = () => {
        if (this.props.loggedUser.canEdit(resources.FUNCTION_OPEN_BROWSER)) {
            return (
                <a href={config.HELP_ON_REDLIKE_AUTOTASKS} target="_blank" rel="noopener noreferrer">
                    <Button label={<Translate value="help.help" />} />
                </a>
            );
        }

        return <Button label={<Translate value="help.help" />} onClick={this.handleHelpClick} />;
    };

    getConfirmButton = () => {
        if (this.isValid()) {
            return (
                <Button
                    svgBefore={imgConfirm}
                    label={<Translate value="general.confirm" />}
                    onClick={this.state.create ? this.handleAddClick : this.handleEditClick}
                />
            );
        }

        return (
            <Button
                tooltipText={this.getConfirmBtnTooltipText()}
                label={<Translate value="general.confirm" />}
                disabled
                svgBefore={imgConfirm}
            />
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <div className="col-12 slim-scroll padding-5">
                {this.getActionTypeField()}
                {this.getAutotaskForm()}
            </div>
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.getHelpButton()}
                {this.getConfirmButton()}
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(this.getModalTitle())}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{minWidth: "60%"}}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        loggedUser: store.login.loggedUser,
        language: store.settings.locale,
        colorantList: store.global.allColorantList,
        canisterList: store.rcc.canisterList,
        channelList: store.rcc.channelList,
        autotaskTypes: store.rcc.machine.autotaskTypes,
        cleaningTime: store.settings.cleaningTime,
        recirculationSpeed: store.settings.recirculationSpeed,
        recirculationTime: store.settings.recirculationTime,
        stirringSpeed: store.settings.stirringSpeed,
        stirringTime: store.settings.stirringTime,
        softwareName: store.settings.softwareName
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseAutotaskModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.AUTOTASK_MODAL));
        },
        dispatchOpenWebviewModalWithParams: (params) => {
            dispatch(
                navigationActions.openModalWithParams(componentTypes.MODAL_NO_TAB, componentTypes.WEBVIEW_MODAL, params)
            );
        },
        dispatchAddAutotaskAction: (autotask) => {
            dispatch(autotaskActions.addAutotask(autotask));
        },
        dispatchUpdateAutotaskAction: (autotask) => {
            dispatch(autotaskActions.updateAutotask(autotask));
        }
    };
};

export default AutotaskModal = connect(mapStoreToProps, mapDispatchToProps)(AutotaskModal);
